<script lang="ts">
  import Flex from '$components/layout/Flex.svelte';
  import NavBarLink from '$components/menu/NavBarLink.svelte';
  import Desktop from '$components/utils/Desktop.svelte';
  import Mobile from '$components/utils/Mobile.svelte';
  import NavBarGlobe from '$components/menu/NavBarGlobe.svelte';
  import NavBarBoilerplate from '$components/menu/NavBarBoilerplate.svelte';
  import Button from '$components/elements/Button.svelte';
  import { adminMode } from '$lib/stores';
  import MediaQuery from '$components/utils/MediaQuery.svelte';
  import { currentUser } from '$lib/client/pocketbase';

  let activeMenu = false;

  const query = '(max-width: 720px), (min-width: 1490px)';

  export let login: () => void;
</script>

<NavBarBoilerplate>
  <div class="links" class:links--open={activeMenu}>
    <div
      class="links__main"
      on:click={() => (activeMenu = false)}
      on:keypress={() => (activeMenu = false)}
      role="button"
      tabindex="0"
    >
      <NavBarLink href="/online">Bible online</NavBarLink>
      <NavBarLink href="/o-bibli21">O Bibli21</NavBarLink>
      <NavBarLink href="/ohlasy">Ohlasy</NavBarLink>
      <NavBarLink href="/nadacni-fond">Nadační fond</NavBarLink>
      <NavBarLink href="/klub-bible21"
        ><MediaQuery {query} let:matches>
          {#if matches}
            Klub Bible21
          {:else}
            Klub B21
          {/if}
        </MediaQuery></NavBarLink
      >
      <NavBarLink href="/kontakt">Kontakt</NavBarLink>
      <NavBarLink href="/studijni-bible21"
        ><MediaQuery {query} let:matches>
          {#if matches}
            Studijní Bible21
          {:else}
            Studijní B21
          {/if}
        </MediaQuery></NavBarLink
      >
    </div>

    <div
      class="links__right"
      class:links__right--open={activeMenu}
      on:click={() => (activeMenu = false)}
      on:keypress={() => (activeMenu = false)}
      role="button"
      tabindex="0"
    >
      <Desktop>
        <NavBarGlobe />
      </Desktop>
      {#if $currentUser}
        <Flex
          breakpoints={{
            0: {
              margin: '0 0 0 5vw'
            },
            1080: {
              margin: '0'
            }
          }}
        >
          <Button
            slimness="slim"
            border="1px solid #ecebe5"
            color="transparent"
            textColor="#1d1d1d"
            width="48px"
            on:click={login}
          >
            {$currentUser?.name?.slice(0, 1)}{$currentUser?.surname?.slice(0, 1)}
          </Button>
        </Flex>
        {#if $currentUser && $currentUser.roles.includes('admin')}
          {#if !$adminMode}
            <NavBarLink on:click={() => adminMode.set(!$adminMode)}
              ><MediaQuery {query} let:matches>
                {#if matches}
                  Zapnout Admin mód
                {:else}
                  Admin
                {/if}
              </MediaQuery></NavBarLink
            >
          {:else}
            <NavBarLink on:click={() => adminMode.set(!$adminMode)}
              ><MediaQuery {query} let:matches>
                {#if matches}
                  Vypnout Admin mód
                {:else}
                  Vypnout
                {/if}
              </MediaQuery></NavBarLink
            >
          {/if}
        {/if}
      {:else}
        <NavBarLink on:click={login}
          ><MediaQuery {query} let:matches>
            {#if matches}
              Moje Bible21
            {:else}
              Moje B21
            {/if}
          </MediaQuery></NavBarLink
        >
        <NavBarLink href="/klub-bible21#darujte">Darovat</NavBarLink>
      {/if}
    </div>
  </div>

  <Mobile>
    <Flex gap="26px">
      <NavBarGlobe />
      <div
        class="burger"
        class:burger--open={activeMenu}
        on:click={() => (activeMenu = !activeMenu)}
        on:keypress={() => (activeMenu = !activeMenu)}
      >
        <span />
      </div>
    </Flex>
  </Mobile>
</NavBarBoilerplate>

<style lang="scss">
  .links {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    &__main {
      display: flex;
      justify-content: flex-start;
      gap: 48px;
      margin: 0 auto 0 0;
    }

    &__right {
      display: flex;
      justify-content: flex-end;
      align-items: center;

      margin-right: 69px;
      gap: 48px;
    }
  }

  @include mobile {
    .links {
      display: none;
      &--open {
        display: flex;
        flex-direction: column;
        background-color: $color-white;
        position: absolute;
        top: 56px;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 5px;
        box-shadow: inset 0px 6px 24px rgba(0, 0, 0, 0.05);
        padding: 10px 0;
        height: calc(100dvh - 56px);
      }

      &__main {
        display: contents;
        width: 100%;

        gap: 48px;
        margin: 0 auto 0 0;

        &::after {
          content: '';
          display: block;

          box-sizing: border-box;
          height: 1px;
          width: 90vw;
          margin: 10px auto;

          background-color: $color-medium-gray;
        }
      }
      &__right {
        width: 100%;
        margin-right: 0px;
        display: contents;
      }
    }
    .burger {
      margin-right: 22px;
      margin-left: auto;

      height: 24px;
      width: 24px;
      appearance: none;

      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      position: relative;

      cursor: pointer;
      &::before,
      &::after,
      span {
        content: '';
        display: block;
        width: 18px;
        height: 2px;
        opacity: 1;
        transition: 0.3s ease all;
        background-color: $color-dark-gray;
        border-radius: 1px;
      }
      &::before {
        translate: 0 -3px;
      }
      &::after {
        translate: 0 3px;
      }
      &--open {
        span {
          opacity: 0;
        }
        &::before {
          translate: 0 1.75px; // This value is bit off
          width: 16px;
          height: 1.5px;
          transform: rotate(45deg);

          border-radius: 26px;
        }
        &::after {
          translate: 0 -1.75px; // This value is bit off
          width: 16px;
          height: 1.5px;
          transform: rotate(-45deg);

          border-radius: 26px;
        }
      }
    }
  }
</style>
